import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';

import { Stack, TextButton } from '@myphx-engineering/phx-design-system';

import type { PathwayQuestionnaireConfig } from '../../../configuration/shared';
import { useFillPrescription } from '../../../contexts/fill/use-fill-prescription';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';

import { CoverageQuestionnaire } from './CoverageQuestionnaire';

// Sub-questionnaire config is passed via router location state from
// CoverageQuestionnaire when an option has a subQuestionnaire field.
type LocationState = {
    subQuestionnaire?: PathwayQuestionnaireConfig;
};

export const CoverageSubSelectScreen: FC = () => {
    const { t } = useTranslation('lilly');
    const location = useLocation();
    const { drxId } = useFillPrescription();
    const state = location.state as LocationState | null;

    if (!state?.subQuestionnaire) {
        // No sub-questionnaire state — redirect back to coverage select
        return (
            <Navigate
                replace
                to={getAbsoluteRoute('fill.drxId.coverageSelect', { drxId })}
            />
        );
    }

    return (
        <Stack
            gap="md"
            data-testid="government-insurance-sub-questionnaire-page-root"
        >
            <TextButton
                link
                to={getAbsoluteRoute('fill.drxId.coverageSelect', { drxId })}
                data-testid="government-insurance-sub-questionnaire-back-link"
            >
                {t('fill.coverageSubSelect.backLink')}
            </TextButton>
            <CoverageQuestionnaire
                questionnaire={state.subQuestionnaire}
                testIdPrefix="government-insurance-sub-questionnaire"
            />
        </Stack>
    );
};
